import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (

        <section className="main_container_block_feeds baby_view_more">
                          <div className="main_block_container_feed">
                                <div className="docConnect_heading_video R15_61 doc_connect_top_margin_0">
                                   {highlightsfeed.title}
                                </div>
                                <div className="docConnect_Bg-section_main">
                                    <div className="content-div_view_artical">
                                       <img src={highlightsfeed.bannerImage} alt={highlightsfeed.title} title={highlightsfeed.title} />
                                    </div>
                                    <div className="docConnect_consult_with">
                                         <SliderConsultdoctor page={"dr-carousel-unit"} data={highlightsfeed.data} />
                                    </div>
                                    <div className="doc_connect_cosult">
                                        <button className="M15_42" type="button" tabIndex={0} aria-label='view all'> View all <span data-icon-font="h" className="icon"></span> </button>
                                    </div>
                                </div>
                            </div>
                        </section>

    )
}